import katex from "katex";
import "katex/dist/katex.min.css";

export default function LatexRender({ math }) {
  const html = katex.renderToString(math, {
    throwOnError: false,
    displayMode: true, // use true for block-style equations
  });

  return <div className="leading-none text-left" dangerouslySetInnerHTML={{ __html: html }} />;
}